import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
interface BookingProgressProps {
  steps: readonly string[];
  current: number;
  furthest: number;
  onSelect: (step: number) => void;
}
export function BookingProgress({
  steps,
  current,
  furthest,
  onSelect
}: BookingProgressProps) {
  const progress = (current - 1) / (steps.length - 1);
  return <nav aria-label="Booking progress" data-id="element-30" data-mp="n5q2won93sd9">
      <p className="mb-3 text-[12px] text-muted sm:hidden" data-id="element-31" data-mp="n4eweh2f86ig">
        <span className="text-forest-700" data-id="element-32" data-mp="j4e7g2hp4cx5">{steps[current - 1]}</span> · {current} of {steps.length}
      </p>
      <div className="relative" data-id="element-33" data-mp="e4idyx6mk3vu">
        <div className="absolute left-4 right-4 top-4 h-px bg-forest-700/15" aria-hidden="true" data-id="element-34" data-mp="e3qf9dhqdq1c" />
        <motion.div aria-hidden="true" className="absolute left-4 top-4 h-px origin-left bg-gold-400" style={{
        right: '1rem'
      }} initial={false} animate={{
        scaleX: progress
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-35" data-mp="955hdkpybig2" />
        <ol className="relative flex justify-between" data-id="element-36" data-mp="1vqspi1bjl0b3">
          {steps.map((label, index) => {
          const number = index + 1;
          const done = number < current;
          const active = number === current;
          const reachable = number <= furthest && !active;
          return <li key={label} className="flex flex-col items-center" data-id="element-37" data-mp="1qotogy39yfhb" data-mpi={index}>
                <button type="button" onClick={() => onSelect(number)} disabled={!reachable} aria-current={active ? 'step' : undefined} aria-label={`Step ${number}: ${label}`} className={`flex h-8 w-8 items-center justify-center rounded-full text-[13px] transition-colors duration-200 ease-premium ${active ? 'bg-forest-700 text-gold-300 ring-4 ring-gold-100' : done || number <= furthest ? 'bg-gold-400 text-forest-800 hover:bg-gold-300' : 'bg-ivory-50 text-forest-300 ring-1 ring-forest-700/15'} ${reachable ? 'cursor-pointer' : 'cursor-default'}`} data-id="element-38" data-mp="1c18ove5lyye5">
                  {done ? <CheckIcon size={14} aria-hidden="true" data-id="element-39" data-mp="582qcs8ogknb" /> : <span className="font-display" data-id="element-40" data-mp="87z2nkzpt1q">{number}</span>}
                </button>
                <span className={`mt-2 hidden whitespace-nowrap text-[12px] sm:block ${active ? 'text-forest-700' : 'text-muted'}`} data-id="element-41" data-mp="6db10ef9ktf">
                  {label}
                </span>
              </li>;
        })}
        </ol>
      </div>
    </nav>;
}